/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui';

/* ++++++++++ --------------- INVOICE PAGE - SETTINGS : STYLES --------------- ++++++++++ */
export default {
  invoice: {
    '& .collapsable.opened': {
      maxHeight: pxToEm(5000)
    },
    '& .table': {
      padding: `${pxToEm(10)} 0`,
      '& .tableview': {
        overflow: "visible"
      },
      '& .row': {
        position: 'static'
      },
      '& .column, .singleselectdropdown': {
        color: '#061240',
        position: 'static',
        '& .active-true': {
          position: 'sticky',
          background: 'white',
          zIndex: 7
        },
        '& .active-false': {
          position: 'static',
          zIndex: 0
        }
      },
    },
    "& .configWrapper": {
      width: '45%'
    },
    '& .flexHorizontal': {
      display: 'flex',
      flexDirection: 'row',
      gap: pxToEm(10)
    },
    '& .trashIcon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    '& .navbar': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: pxToEm(14)
    },
    '& .navbar-right': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '& .message': {
      margin: '0px 10px 0px 0px'
    },
    '& .searchbar': {
      width: '25%'
    },
    '& .yearNav': {
      color: themeV2.color.base.gray.secondary
    },
    '& .centerContent' :{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  updateSuccess: {
    color: themeV2.color.success.main
  },
  updateFailed: {
    color: themeV2.color.error.main
  },
  icon: {
    color: themeV2.color.base.gray.secondary,

    '&:hover': {
      color: themeV2.color.primary.main
    }
  },
  downloadIcon: {
    color: themeV2.color.base.gray.secondary,
    paddingRight: pxToEm(28),

    '&:hover': {
      color: themeV2.color.primary.main
    }
  },
  invoicePreview: {
    '& .topPanel': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: pxToEm(20),
      whiteSpace: 'nowrap'
    },
    '& .buttonsTop': {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '& .buttonsBtm': {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: pxToEm(20),
    },
    '& .btnDownload':{
      border: '1px solid #061240',
      backgroundColor: 'white',
      marginRight: pxToEm(20),

      '& i': {
        color: themeV2.color.primary.main,
        fontSize: '100%',
        padding: 0
      }
    },
    '& .btnClose': {
      backgroundColor: themeV2.color.primary.main,
      color: 'white'
    },
    '& .prevPage': {
      position: 'absolute !important',
      zIndex: 1
    },
    '& .annotationLayer' :{
      display: 'none'
    },
    '& .expandablePdf': {
      'border': 'none',

      '& .innerWrap': {
        backgroundColor: 'white'
      },

      '& .footer': {
        display: 'none'
      }
    },
    '& .react-pdf__Document': {
      position: 'relative',

      '&:hover': {
        '& .page-controls': {
          opacity: 1
        }
      }
    },
    '& .page-controls': {
      position: 'absolute',
      bottom: '2%',
      left: '50%',
      background: 'white',
      opacity: '0',
      transform: 'translateX(-50%)',
      transition: 'opacity ease-in-out 0.2s',
      borderRadius: '4px',

      '& span': {
        font: 'inherit',
        fontSize: '.8em',
        padding: '0 .5em'
      },

      '& button': {
        width: '44px',
        height: '44px',
        background: 'white',
        border: 0,
        font: 'inherit',
        fontSize: '.8em',
        borderRadius: '4px',

        '&:enabled': {
          '&:hover': {
            cursor: 'pointer'
          },

          '&:hover, &:focus': {
            backgroundColor: '#e6e6e6'
          }
        },

        '&:first-child': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },

        '&:last-child': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      }
    }
  }
};